interface Positioned {
  lat: number;
  lng: number;
}

export const MAP_DEFAULTS = {
  CENTER: [0, 0] as [number, number],
  ZOOM: 6
} as const;

export function calculateMapCenter(points: Positioned[], configCenter?: [number, number]): [number, number] {
  if (configCenter) return configCenter;
  if (points.length === 0) return MAP_DEFAULTS.CENTER;

  const lats = points.map((point) => point.lat);
  const lngs = points.map((point) => point.lng);

  return [(Math.min(...lats) + Math.max(...lats)) / 2, (Math.min(...lngs) + Math.max(...lngs)) / 2];
}
